import Drawer, { DrawerProps } from '@material-ui/core/Drawer';
import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from './styles';

export interface DrawerPopupProps extends DrawerProps {
  handleClose: () => void;
  paperClassName?: string;
  backgroundColor?: string;
  showShadow?: boolean;
  className?: string;
  grayBackground?: string;
}

export const DrawerPopup: FC<DrawerPopupProps> = ({ children, handleClose, paperClassName = '', ...otherProps }) => {
  const classes = useStyles();

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classNames(classes.drawer, paperClassName) }}
      disableEnforceFocus
      onClose={handleClose}
      {...otherProps}
    >
      {children}
    </Drawer>
  );
};
